import { render, staticRenderFns } from "./RadioCard.vue?vue&type=template&id=5659ba67&scoped=true"
import script from "./RadioCard.vue?vue&type=script&lang=js"
export * from "./RadioCard.vue?vue&type=script&lang=js"
import style0 from "./RadioCard.vue?vue&type=style&index=0&id=5659ba67&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5659ba67",
  null
  
)

export default component.exports